import { getAuth } from "firebase/auth";

interface ApiHeaders {
  'Content-Type': string;
  'Accept': string;
  'Authorization'?: string;
}

const apiConfig = {
  baseUrl: 'https://europe-central2-wannabe-entrepreneur.cloudfunctions.net',
  defaultHeaders: {
    'Content-Type': 'multipart/form-data',
    'Accept': 'application/json'
  } as ApiHeaders
};

export async function fetchPodSqueezeAPI(
  endpoint: string,
  method: string,
  customPayload: Record<string, any>,
  extraOptions = {}
) {
  const headers = { ...apiConfig.defaultHeaders };
  const payload = { ...customPayload };

  // Only try to get Firebase token for authenticated endpoints
  if (endpoint === "/podsqueeze" || 
      (endpoint === "/podsqueeze_payments" && 
       (payload.mode === "payment_link" || payload.mode === "gift_payment_link")) ||
      endpoint === "/podsqueeze_api") {
    try {
      const auth = getAuth();
      const token = await auth.currentUser?.getIdToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (error) {
      // If Firebase is not initialized, continue without auth token
      console.log("Firebase not initialized, proceeding without auth token");
    }
  }

  // Build final URL without mutating global baseUrl
  let baseUrl = apiConfig.baseUrl;
  let finalPath = endpoint; // default
  if (endpoint === "/podsqueeze_api") {
    // This endpoint is a top-level function (no extra path segment)
    baseUrl = "https://europe-central2-wannabe-entrepreneur.cloudfunctions.net";
    finalPath = "/podsqueeze-api";
  }

  const config = {
    method: method,
    headers: headers,
    body: JSON.stringify(payload)
  };

  try {
    const response = await fetch(`${baseUrl}${finalPath}`, config);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch from PodSqueeze API:", error);
    throw error;
  }
}

